<template>
<div>
    <div v-if="submitted" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="100vw" :srcset="require('@/assets/images/NewSelf_Logo-p-500.webp') + ' 500w, ' + require('@/assets/images/NewSelf_Logo-p-800.webp') + ' 800w, ' + require('@/assets/images/NewSelf_Logo.webp') + ' 1000w'" alt="" :src="require('@/assets/images/NewSelf_Logo.webp')" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el > 1">
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651" style="margin-bottom: 3px;"></a>
                </div>
                <div class="mobile-nav-links">
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img src="@/assets/images/icon_call_1.svg" loading="lazy" alt="" class="image-692"></a>
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()" v-if="active_el > 1"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: Math.round((active_el / (totalSteps + 1)) * 100) + '%' }"></div>
            </div>
        </div>
    </section>
    <section class="section-fixed-controlnav hide-block">
        <div class="flow-ctrl-nav-wrap">
            <div class="ctrl-div">
                <div class="ctrl-div-flex">
                    <a href="#" class="back-button w-button" v-if="active_el > 1" @click.prevent="GoBack()">Back</a>
                    <a href="#" class="continue-button w-button" @click.prevent="handleSubmit">Continue</a>
                </div>
            </div>
        </div>
    </section>
    <section class="section_checkout-flow">
        <div class="flow_wrap">

            <!-- Step 1: Hero Landing -->
            <div class="step_forminfo_div" v-if="active_el === 1">
                <div class="question-container">
                    <div class="w-form">
                        <form id="email-form-2" @submit.prevent="handleSubmit">
                            <div class="form-hero-div"><img sizes="100vw" :srcset="require('@/assets/images/stepsimage_teledoc_nS-p-500.webp') + ' 500w, ' + require('@/assets/images/stepsimage_teledoc_nS.webp') + ' 641w'" alt="" :src="require('@/assets/images/stepsimage_teledoc_nS.webp')" loading="lazy" class="enroll-top-image">
                                <div class="enroll-header">Get Better. Today.</div>
                                <p class="formhero-sub"><em>Fast online care to help relieve your symptoms today.</em></p>
                                <div class="form-3-things-div-copy">
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div"><img :src="require('@/assets/images/checkout_quiz.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/checkout_quiz-p-500.webp') + ' 500w, ' + require('@/assets/images/checkout_quiz-p-800.webp') + ' 800w, ' + require('@/assets/images/checkout_quiz.webp') + ' 1080w'" alt="" class="icon-img-copy _2"></div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Tell us whats wrong<br></div>
                                                    <div class="process-step-sub">Fill out a short form about your symptoms. </div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new"></div>
                                            <div class="div-block-1778"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602"></div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div"><img :src="require('@/assets/images/checkout_checkup.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/checkout_checkup-p-500.webp') + ' 500w, ' + require('@/assets/images/checkout_checkup-p-800.webp') + ' 800w, ' + require('@/assets/images/checkout_checkup.webp') + ' 1080w'" alt="" class="icon-img-copy _2"></div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Online Doctor Review<br></div>
                                                    <div class="process-step-sub">A licensed doctor reviews your case.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new"></div>
                                            <div class="div-block-1778"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602"></div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div ship"><img :src="require('@/assets/images/StepsImage_products.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/4510bb3b9c41caa95c08d0cd8266eeec_StepsImage_products-p-500.webp') + ' 500w, ' + require('@/assets/images/4510bb3b9c41caa95c08d0cd8266eeec_StepsImage_products-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_products.webp') + ' 1080w'" alt="" class="icon-img-copy ship"></div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy"><strong>Prescription to Pharmacy</strong></div>
                                                    <div class="process-step-sub">Medication sent to your local pharmacy.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new"></div>
                                            <div class="div-block-1778"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602"></div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                </div>
                                <div class="enroll-form-button-div">
                                    <a href="#" class="enroll-form-submit-button-copy top w-button" style="text-align: center;" @click.prevent="handleSubmit">Start my Urgent Care visit -&gt;</a>
                                </div>
                                <div class="form-disclaimer-div"><label class="w-checkbox enroll-checkbox-field"><input type="checkbox" name="checkbox-3" id="checkbox-3" checked data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top"><span class="enroll-checkbox-label w-form-label" for="checkbox-3">I Agree to NewSelf&#x27;s <a href="https://newself.com/terms-of-use" class="enroll-checkbox-link">Terms</a>, <a href="https://newself.com/privacy-policy" class="enroll-checkbox-link">Privacy Policy</a> and consent to <a href="https://newself.com/telehealth-consent" class="enroll-checkbox-link">Telehealth</a></span></label></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Step 2: Name, DOB, Sex -->
            <div class="step_forminfo_div" v-if="active_el === 2">
                <div v-if="isSubmitting" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#0c9ac4" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers line-break">Enter your details to save your progress</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" @submit.prevent="handleSubmit">
                            <div class="doc-bar-div"><img :src="require('@/assets/images/Doctor_newself.webp')" loading="lazy" sizes="(max-width: 767px) 100vw, 755.0000610351562px" :srcset="require('@/assets/images/Doctor_newself-p-500.webp') + ' 500w, ' + require('@/assets/images/Doctor_newself.webp') + ' 755w'" alt="" class="image-687">
                                <div>
                                    <div class="text-block-1721">A doctor will prescribe your medication in less than 24 hours.</div>
                                </div>
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">First name*</div><input class="checkout-flow-input w-input" maxlength="256" name="first-name" data-name="first name" placeholder="Your first name" type="text" id="first-name" required="" v-model="people.first_name" :class="{ 'field-error': fieldErrors.first_name }">
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">Last name*</div><input class="checkout-flow-input w-input" maxlength="256" name="last-name" data-name="last name" placeholder="Your last name" type="text" id="last-name" required="" v-model="people.last_name" :class="{ 'field-error': fieldErrors.last_name }">
                            </div>
                            <div class="form-field-label">Date of birth*</div>
                            <div class="flex-input-div dob">
                                <div class="selectwrap">
                                    <span class="select-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0" aria-hidden="true" width="18" height="18">
                                            <path d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z"></path>
                                            <path d="M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z"></path>
                                            <path d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z"></path>
                                            <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"></path>
                                            <path d="M7 14C7.55229 14 8 13.5523 8 13C8 12.4477 7.55229 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14Z"></path>
                                            <path d="M7 18C7.55229 18 8 17.5523 8 17C8 16.4477 7.55229 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z"></path>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V3.26272C8.412 3.24999 9.14133 3.24999 9.94346 3.25H14.0564C14.8586 3.24999 15.588 3.24999 16.25 3.26272V2.5C16.25 2.08579 16.5858 1.75 17 1.75C17.4142 1.75 17.75 2.08579 17.75 2.5V3.32709C18.0099 3.34691 18.2561 3.37182 18.489 3.40313C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33855 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V14.0564C22.75 15.8941 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0565 22.75H9.94359C8.10585 22.75 6.65018 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3588C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33855 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40313C5.7439 3.37182 5.99006 3.34691 6.25 3.32709V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM5.71085 4.88976C4.70476 5.02502 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02502 6.70476 2.88976 7.71085C2.86685 7.88123 2.8477 8.06061 2.83168 8.25H21.1683C21.1523 8.06061 21.1331 7.88124 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02502 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976ZM2.75 12C2.75 11.146 2.75032 10.4027 2.76309 9.75H21.2369C21.2497 10.4027 21.25 11.146 21.25 12V14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25H10C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14V12Z"></path>
                                        </svg></span>
                                    <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" name="birth-month" data-name="birth month" placeholder="MM" type="text" id="birth-month" required="" inputmode="numeric" v-model="people.dob.mm" @input="handleDobInput($event, 'mm', 'birth-month', 'birth-day', 2)" :class="{ 'field-error': fieldErrors.dob_mm }">
                                </div>
                                <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" name="birth-day" data-name="birth day" placeholder="DD" type="text" id="birth-day" required="" inputmode="numeric" v-model="people.dob.dd" @input="handleDobInput($event, 'dd', 'birth-day', 'birth-year', 2)" :class="{ 'field-error': fieldErrors.dob_dd }">
                                <input class="checkout-flow-input thirds w-input" maxlength="4" pattern="[0-9]*" name="birth-year" data-name="birth year" placeholder="YYYY" type="text" id="birth-year" required="" inputmode="numeric" v-model="people.dob.yyyy" @input="handleDobInput($event, 'yyyy', 'birth-year', null, 4)" :class="{ 'field-error': fieldErrors.dob_yyyy }">
                            </div>

                            <div class="form-field-label">Sex assigned at birth*</div>
                            <div class="selectwrap">
                                <span class="select-icon" aria-hidden="true"> <svg viewBox="0 0 16 16" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0 text-secondary-400" aria-hidden="true" width="18" height="18">
                                        <path d="M3.47845 6.89783C3.47845 4.95347 5.05467 3.37725 6.99903 3.37725C8.94339 3.37725 10.5196 4.95347 10.5196 6.89783C10.5196 8.84217 8.94328 10.4184 6.99889 10.4184C5.05456 10.4184 3.47845 8.84222 3.47845 6.89783ZM6.99903 2.19631C4.40245 2.19631 2.29751 4.30125 2.29751 6.89783C2.29751 9.29443 4.09049 11.2721 6.40843 11.5626V12.5533H5.53082C5.20471 12.5533 4.94035 12.8177 4.94035 13.1438C4.94035 13.4699 5.20471 13.7342 5.53082 13.7342H6.40847L6.40858 15.1993C6.4086 15.5255 6.67299 15.7898 6.99909 15.7898C7.3252 15.7897 7.58954 15.5254 7.58952 15.1993L7.58941 13.7342H8.46728C8.79339 13.7342 9.05775 13.4699 9.05775 13.1438C9.05775 12.8177 8.79339 12.5533 8.46728 12.5533H7.58936V11.5626C9.90729 11.2721 11.7005 9.29447 11.7005 6.89783C11.7005 4.30125 9.59561 2.19631 6.99903 2.19631Z"></path>
                                        <path fill-rule="evenodd" d="M10.2124 0.745546C10.2124 0.532708 10.385 0.360168 10.5978 0.360168H13.167C13.3798 0.360168 13.5524 0.532708 13.5524 0.745546V3.31473C13.5524 3.52757 13.3798 3.70011 13.167 3.70011C12.9542 3.70011 12.7816 3.52757 12.7816 3.31473V1.67593L10.441 4.01652C11.1 4.7987 11.497 5.80878 11.497 6.91159C11.497 9.3947 9.48407 11.4077 7.00096 11.4077C4.51784 11.4077 2.50488 9.3947 2.50488 6.91159C2.50488 4.42848 4.51784 2.41552 7.00096 2.41552C8.10377 2.41552 9.11384 2.81257 9.89603 3.47151L12.2366 1.13092H10.5978C10.385 1.13092 10.2124 0.958384 10.2124 0.745546ZM7.00096 3.18627C4.94352 3.18627 3.27564 4.85415 3.27564 6.91159C3.27564 8.96902 4.94352 10.6369 7.00096 10.6369C9.05839 10.6369 10.7263 8.96902 10.7263 6.91159C10.7263 4.85415 9.05839 3.18627 7.00096 3.18627Z"></path>
                                    </svg>
                                </span>
                                <select id="field-2" name="field-2" data-name="Field 2" class="checkout-flow-dropdown w-select" v-model="people.gender" :class="{ 'field-error': fieldErrors.gender }">
                                    <option value="">Select an option...</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>

                            <div class="flow-payment-div">
                                <div class="div-block-2247 phone">
                                    <button class="pay-button w-button" @click.prevent="handleSubmit" :disabled="isSubmitting">
                                        <span v-if="isSubmitting">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                                    </animateTransform>
                                                </circle>
                                            </svg>
                                        </span>
                                        <span v-else>Continue</span></button>
                                </div>
                            </div>

                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 3: Email and Phone -->
            <div class="step_forminfo_div" v-if="active_el === 3">
                <div v-if="isSubmitting" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#0c9ac4" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers line-break">Enter your contact details</div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" @submit.prevent="handleSubmit">
                            <div class="flow-form-full-div">
                                <div class="form-field-label">Email*</div>
                                <input class="checkout-flow-input w-input" maxlength="256" name="email" data-name="email" placeholder="Email address" type="email" id="email" required="" v-model="people.email" @blur="checkEmailOnBlur" :class="{ 'field-error': fieldErrors.email, 'email-error-highlight': emailCheckError }">
                                <div v-if="emailCheckError" class="email-check-error">{{ emailCheckError }}</div>
                                <p class="paragraph-218">By entering your email, we&#x27;ll save your progress and send you updates about your care. You can unsubscribe anytime. View our <a href="https://newself.com/terms-of-use" target="_blank" class="link-89">Terms &amp; Conditions</a>.</p>
                            </div>

                            <div class="flow-form-full-div">
                                <div class="form-field-label">Phone Number*</div>
                                <input class="checkout-flow-input w-input" maxlength="16" data-name="phone" placeholder="(XXX) XXX-XXXX" type="text" pattern="[0-9()\s-]*" required autocomplete="off" inputmode="numeric" v-model="phoneDisplay" @input="handlePhoneInput" :class="{ 'field-error': fieldErrors.phone }">
                                <div class="sms-consent-row" :class="{ 'sms-consent-shake': smsConsentShake, 'sms-consent-row-error': smsConsentError }">
                                    <input type="checkbox" id="checkbox-sms" name="checkbox-sms" class="sms-consent-checkbox" v-model="people.agree_to_phone" @change="smsConsentError = ''">
                                    <label for="checkbox-sms" class="sms-phone-disclaimer">By checking the box, you agree that NewSelf can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.newself.com/privacy-policy" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Privacy Policy</a> and <a href="https://newself.com/terms-of-use" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Terms</a>.</label>
                                </div>
                            </div>

                            <div v-if="showErrorPopup" class="w-form-fail" style="display:block; margin: 0 0 12px; padding: 10px; text-align: center;">
                                <div>{{ errorMessage }}</div>
                            </div>
                            <div class="flow-payment-div">
                                <div class="div-block-2247 phone sms-actions">
                                    <div v-if="smsConsentError" class="sms-consent-error">{{ smsConsentError }}</div>
                                    <button class="pay-button w-button" @click.prevent="handleSubmit" :disabled="isSubmitting || isCheckingEmail">
                                        <span v-if="isSubmitting || isCheckingEmail">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                                    </animateTransform>
                                                </circle>
                                            </svg>
                                        </span>
                                        <span v-else>Continue</span></button>
                                </div>
                            </div>

                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 4: Pharmacy Info -->
            <div class="quizquestiondiv2-copy ad" v-if="active_el === 4">
                <div class="quiz-img-div ad flow"><img :src="require('@/assets/images/StepsImage_logos.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_logos-p-500.png') + ' 500w, ' + require('@/assets/images/StepsImage_logos-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_logos.webp') + ' 1080w'" alt="" class="image-662 flow outline"></div>
                <div class="quizquestionheader-cop">Connected to all licensed <br>local pharmacies.</div>
                <p class="paragraph-208 center"><strong>After your visit, we'll send your prescription (if prescribed) </strong>to your local pharmacy for quick pickup. Many pharmacies also offer delivery.</p>
                <a href="#" class="button-167-copy w-button" @click.prevent="handleSubmit">Continue <span class="text-span-398">-&gt;</span></a>
            </div>

            <!-- Step 5: Inclusions / Pricing -->
            <div class="step4_div" v-if="active_el === 5">
                <div class="inclusions-new">
                    <div class="flow-inclusions-header">Get the Support You Need.</div>
                    <div class="text-block-1705">What&#x27;s included</div>
                    <div class="flow_inclusions-div">
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img :src="require('@/assets/images/StepsImage_doc.png')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_doc-p-500.png') + ' 500w, ' + require('@/assets/images/StepsImage_doc-p-800.png') + ' 800w, ' + require('@/assets/images/StepsImage_doc.png') + ' 1080w'" alt=""></div>
                                <div class="inclusions-text-div product">
                                    <div class="text-block-1706">Urgent Care Clinical Visit</div>
                                    <p class="inclusions-subs">100% online. A doctor will review your medical form &amp; help you get better.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="div-block-2249 top-float">
                                    <div class="text-block-1710">$59</div>
                                    <div class="text-block-1711-copy">${{ Math.floor(getTotalOrderAmount()) }}<span><sup class="superscript-11">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img :src="require('@/assets/images/StepsImage_products.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/4510bb3b9c41caa95c08d0cd8266eeec_StepsImage_products-p-500.webp') + ' 500w, ' + require('@/assets/images/4510bb3b9c41caa95c08d0cd8266eeec_StepsImage_products-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_products.webp') + ' 1080w'" alt="" class="image-681"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Local Pharmacy Prescriptions</div>
                                    <p class="inclusions-subs">We will use our software platform to send your prescription to your local pharmacy.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img :src="require('@/assets/images/StepsImage_phonechat.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_phonechat-p-500.webp') + ' 500w, ' + require('@/assets/images/StepsImage_phonechat-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_phonechat.webp') + ' 1080w'" alt="" class="image-694"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">After Care Clinician Chat</div>
                                    <p class="inclusions-subs">Have questions after your visit? Message our team anytime.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img src="@/assets/images/icon_discount.webp" loading="lazy" alt="" class="image-682"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Discounted Therapies</div>
                                    <p class="inclusions-subs">Every member gets access to discounted therapies to help lead a healthier life.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="text-block-1708">Included</div>
                            </div>
                        </div>
                    </div>
                    <div class="row-divider"></div>
                    <div class="div-block-2248 total">
                        <div class="text-block-1712">Total</div>
                        <div class="div-block-2249">
                            <div class="div-block-2250"><img src="@/assets/images/icon_tag.svg" loading="lazy" alt="" class="image-688">
                                <div class="text-block-1722">NEW PATIENT DISCOUNT</div>
                            </div>
                            <div class="text-block-1710">$59</div>
                            <div class="text-block-1711">${{ Math.floor(getTotalOrderAmount()) }}<span><sup class="superscript-11">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span></div>
                        </div>
                    </div>
                    <div class="trust-pilot-div"><img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
                        <div class="flow-rating-div">
                            <div class="text-block-1723">Excellent</div>
                            <div class="text-block-1724">4.5 out of 5</div><img :src="require('@/assets/images/Trustpilot_Logo_2022.svg.webp')" loading="lazy" sizes="(max-width: 2560px) 100vw, 2560px" :srcset="require('@/assets/images/Trustpilot_Logo_2022.svg-p-500.png') + ' 500w, ' + require('@/assets/images/Trustpilot_Logo_2022.svg-p-800.png') + ' 800w, ' + require('@/assets/images/Trustpilot_Logo_2022.svg-p-1080.png') + ' 1080w, ' + require('@/assets/images/Trustpilot_Logo_2022.svg.webp') + ' 2560w'" alt="" class="image-690">
                        </div>
                        <div>Trusted by thousands of members</div>
                    </div>
                    <div class="flow-ctrls-div">
                        <a href="#" class="form-back-link w-inline-block" @click.prevent="GoBack()">
                            <div class="text-block-1719">&lt;-</div>
                            <div class="text-block-1718">Back</div>
                        </a>
                        <a href="#" class="continue-button step w-button" @click.prevent="handleSubmit">Continue <span class="text-span-423">-&gt;</span></a>
                    </div>
                </div>
            </div>

            <!-- Step 6: Payment -->
            <div class="step6_div" v-if="active_el === 6">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Payment details</div>

                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get">
                            <div class="flow-payment-div">
                                <div data-hover="false" data-delay="0" class="flow-dropdown-sum w-dropdown">
                                    <div class="flow-sum-droptoggle w-dropdown-toggle" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                        <div class="icon-49 w-icon-dropdown-toggle"></div>
                                        <div class="drop-sum-label-div div-block-2244">
                                            <div class="text-block-1701">Due Today </div>
                                            <div class="text-block-1701">${{ Math.floor(getTotalOrderAmount()) }}<span class="text-span-418"><sup>{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span></div>
                                        </div>
                                    </div>
                                    <nav class="dropdown-list-18 w-dropdown-list" :class="{'w--open' : summeryOpen}">
                                        <div class="flow-sum-maindiv">
                                            <div class="flow-summary-top">
                                                <div class="text-block-1688-copy"><strong>Order Summary</strong></div>
                                            </div>
                                            <div class="flow-sum-orders-div">
                                                <div class="order-line-div">
                                                    <div class="order-name">Urgent Care Consultation</div>
                                                    <div class="div-block-2243">
                                                        <div class="order-price">${{ Math.floor(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup> </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="order-total-div">
                                                <div class="text-block-1698">Due today</div>
                                                <div class="div-block-2243">
                                                    <div class="order-price-total">${{ Math.floor(getTotalOrderAmount()) }}<sup class="superscript-9-copy">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup> </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1705">What&#x27;s included</div>
                                            <div class="inclusions-new">
                                                <div class="flow_inclusions-div">
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="require('@/assets/images/StepsImage_doc.png')" loading="lazy" width="107" sizes="107px" alt="" :srcset="require('@/assets/images/StepsImage_doc-p-500.png') + ' 500w, ' + require('@/assets/images/StepsImage_doc-p-800.png') + ' 800w, ' + require('@/assets/images/StepsImage_doc.png') + ' 1080w'" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Clinician Chat Consultation</div>
                                                                <p class="inclusions-subs">Consult with Board-certified experts</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="require('@/assets/images/StepsImage_products.webp')" loading="lazy" sizes="127px" :srcset="require('@/assets/images/4510bb3b9c41caa95c08d0cd8266eeec_StepsImage_products-p-500.webp') + ' 500w, ' + require('@/assets/images/4510bb3b9c41caa95c08d0cd8266eeec_StepsImage_products-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_products.webp') + ' 1080w'" alt="" class="image-682"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Local Pharmacy Prescriptions</div>
                                                                <p class="inclusions-subs">We will use our software platform to send your prescription to your local pharmacy.</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="require('@/assets/images/StepsImage_phonechat.webp')" loading="lazy" sizes="127px" :srcset="require('@/assets/images/StepsImage_phonechat-p-500.webp') + ' 500w, ' + require('@/assets/images/StepsImage_phonechat-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_phonechat.webp') + ' 1080w'" alt="" class="image-694"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">After Care Clinician Chat</div>
                                                                <p class="inclusions-subs">Have questions after your visit? Message our team anytime.</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="div-block-2248">
                                                    <div class="text-block-1712">Total</div>
                                                    <div class="div-block-2249">
                                                        <div class="text-block-1711">${{ Math.floor(getTotalOrderAmount()) }}<span><sup class="superscript-11">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flow-sum-guarantee-div">
                                                <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you&#x27;re not eligible, we&#x27;ll issue a full refund</p>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                                <div class="text-block-1704">Payment Method</div>

                                <!-- Express Checkout -->
                                <div class="express-checkout-section">
                                    <div class="express-checkout-box">
                                        <express-checkout-button
                                            :amount="amountInCents"
                                            @token="handleExpressPayment"
                                        />
                                    </div>
                                    <div class="pe-divider">
                                        <div class="pe-divider-line"></div>
                                        <span>OR</span>
                                        <div class="pe-divider-line"></div>
                                    </div>
                                </div>

                               
                                <stripe-payment-element
                                    ref="stripePayment"
                                    :base-url="baseUrl"
                                    :user-id="user?.id"
                                    :user-name="people.first_name + ' ' + people.last_name"
                                    :user-email="people.email"
                                    :hide-address-fields="true"
                                    :billing-address="customerInfo"
                                    @ready="hasCardInput = $event"
                                    @error="handlePaymentError"
                                    @token="handlePaymentToken"
                                />

                                <div class="address-section">
                                    <label class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                    <div :class="{ 'address-highlight': addressBlink }">
                                        <google-places-autocomplete-new :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                                    </div>
                                </div>

                                <!-- Payment Error Display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block; margin-top: 15px; margin-bottom: 15px;">
                                    <div>{{ errorMessage }}</div>
                                </div>

                                <div class="div-block-2247">
                                    <button type="button" @click.prevent="getStripeToken" :disabled="submitted" class="pay-button w-button">
                                        {{ submitted ? 'Processing...' : 'Pay' }}
                                    </button>
                                    <p class="paragraph-185-copy">
                                        By clicking "Pay Now" you agree to enroll in a {{ paymentInfo.payment_terms }}-month program{{ paymentInfo.payment_terms > 1 ? ' billed upfront' : ' billed monthly' }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the
                                        <a href="https://newself.com/returns-and-refund" target="_blank">Refund Policy</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms and Conditions</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms of Use</a>,
                                        <a href="https://newself.com/privacy-policy" target="_blank">Privacy Policy</a>, and
                                        <a href="/documents/Telehealth_Consent_Form.pdf" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>

                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <PaidUserModal
        :visible="showPaidUserModal"
        :email="people.email"
        :reason="paidUserReason"
        :role="paidUserRole"
        @close="showPaidUserModal = false" />
</div>
</template>

<script>
import StripePaymentElement from '../common/StripePaymentElement.vue'
import { cleanUsPhone, cleanUsPhoneInput, formatUsPhone, isValidUsPhone } from '@/utils/phone'
import ExpressCheckoutButton from '../common/ExpressCheckoutButton.vue'
import GooglePlacesAutocompleteNew from '../common/GooglePlacesAutocomplete_new.vue'
import state from "@/utils/state.json"
import { isRestrictedState, RESTRICTED_STATE_MESSAGE } from '@/utils/restrictedStates'
import { checkEmail, isValidEmailFormat } from '@/utils/checkEmail';
import PaidUserModal from '../common/PaidUserModal.vue';
import {
    mapActions,
    mapGetters
} from 'vuex'

export default {
    name: 'UrgentCareNewCheckout',
    components: {
        StripePaymentElement,
        GooglePlacesAutocompleteNew,
        PaidUserModal,
        ExpressCheckoutButton
    },
    props: ['baseUrl', 'googleMapsApiKey'],
    data() {
        return {
            allState: state,
            active_el: 1,
            totalSteps: 6,
            formErrors: {
                emailConsent: ''
            },
            fieldErrors: {},
            smsConsentError: '',
            smsConsentShake: false,
            isSubmitting: false,
            showErrorPopup: false,
            errorMessage: '',
            summeryOpen: false,
            emailCheckError: '',
            isCheckingEmail: false,
            showPaidUserModal: false,
            paidUserReason: 'paid_user',
            paidUserRole: '',
            // Payment-related data
            hasCardInput: false,
            addressBlink: false,
            submitted: false,
            correlationId: null,
            paymentError: false,
            paymentAttempts: 0,
            maxPaymentAttempts: 3,

            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 0,
                user_id: '',
                cardToken: '',
                cardBrand: '',
                amount: 39.99,
                medication: 'urgentcare',
                paymentMethod: null,
                cardDetails: [],
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
                discount: 0,
            },

            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                gender: '',
                agreed_to_text: "Yes",
                agree_to_phone: false,
                agreed_to_terms: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                user_agent: "",
                ip_address: '',
                tracking_session_id: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                }
            }
        }
    },
    async mounted() {
        // Initialize tracking session
        try {
            const sessionId = await window.tracking.assertSession();
            this.people.tracking_session_id = sessionId;
        } catch(error) {
            if (window.trackingSessionId) {
                this.people.tracking_session_id = window.trackingSessionId;
            }
        }

        // Load saved progress from session storage
        this.loadProgress();
        this.getIpAddress();

        // Pre-fill form from logged-in user data
        this.prefillFromUserData();
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    },
    computed: {
        ...mapGetters(['user', 'isAuthenticated']),

        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },

        phoneDisplay: {
            get() {
                // Show an optional "1 " country code, e.g. "1 (555) 555-5555"
                return formatUsPhone(this.people.phone);
            },
            set(value) {
                // Keep an optional leading 1 country code; cap national part at 10
                this.people.phone = cleanUsPhoneInput(value);
            }
        },

        // Payment-related computed properties
        amountInCents() {
            return Math.round(this.getTotalOrderAmount() * 100);
        },

    },
    methods: {
        ...mapActions([]),

        async checkEmailOnBlur() {
            this.emailCheckError = '';
            if (!this.people.email || !isValidEmailFormat(this.people.email)) {
                return;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                }
            } catch (e) {
                // Never block on error
            } finally {
                this.isCheckingEmail = false;
            }
        },
        async handleEmailCheck() {
            this.emailCheckError = '';
            if (!isValidEmailFormat(this.people.email)) {
                return true;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                    return false;
                }
                return true;
            } catch (e) {
                return true;
            } finally {
                this.isCheckingEmail = false;
            }
        },

        async handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
                if (this.$refs.stripePayment) {
                    this.$refs.stripePayment.resetElement();
                }
            }
        },

        // Save checkout progress to session storage
        saveProgress() {
            try {
                const progressData = {
                    active_el: this.active_el,
                    people: this.people,
                    timestamp: Date.now()
                };
                sessionStorage.setItem('urgentCareNewCheckoutProgress', JSON.stringify(progressData));
            } catch (error) {
                console.error('Error saving progress:', error);
            }
        },

        // Load checkout progress from session storage
        loadProgress() {
            try {
                const savedProgress = sessionStorage.getItem('urgentCareNewCheckoutProgress');
                if (savedProgress) {
                    const progressData = JSON.parse(savedProgress);

                    // Only restore if saved within last 24 hours
                    const dayInMs = 24 * 60 * 60 * 1000;
                    if (Date.now() - progressData.timestamp < dayInMs) {
                        this.active_el = progressData.active_el || 1;
                        this.people = {
                            ...this.people,
                            ...progressData.people
                        };
                    } else {
                        // Clear expired data
                        sessionStorage.removeItem('urgentCareNewCheckoutProgress');
                    }
                }
            } catch (error) {
                console.error('Error loading progress:', error);
            }
        },

        // Clear saved progress
        clearProgress() {
            try {
                sessionStorage.removeItem('urgentCareNewCheckoutProgress');
            } catch (error) {
                console.error('Error clearing progress:', error);
            }
        },

        handleDobInput(event, field, currentFieldId, nextFieldId, maxLength) {
            // Extract only numeric characters from input
            const value = event.target.value.replace(/\D/g, '');
            
            // Update the v-model with numeric-only value
            this.people.dob[field] = value;
            
            // Auto-advance to next field when max length is reached
            if (value.length === maxLength && nextFieldId) {
                this.autoAdvanceDobField(currentFieldId, nextFieldId, maxLength);
            }
        },

        autoAdvanceDobField(currentFieldId, nextFieldId, maxLength) {
            const currentField = document.getElementById(currentFieldId);
            if (currentField && currentField.value.length === maxLength) {
                const nextField = document.getElementById(nextFieldId);
                if (nextField) {
                    nextField.focus();
                }
            }
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        handlePhoneInput(event) {
            // Cap to 10 digits, then force the displayed value so extra
            // keystrokes can't linger past the cap.
            this.people.phone = cleanUsPhoneInput(event.target.value);
            event.target.value = formatUsPhone(this.people.phone);
            if (this.fieldErrors.phone) this.clearFieldError('phone');
            if (this.showErrorPopup) this.showErrorPopup = false;
        },

        clearFieldError(field) {
            if (this.fieldErrors[field]) {
                this.$set(this.fieldErrors, field, false);
            }
        },

        setFieldError(field, hasError = true) {
            this.$set(this.fieldErrors, field, hasError);
        },

        GoBack() {
            if (this.active_el > 1) {
                this.active_el--;
                this.fieldErrors = {};
            }
        },

        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },

        showError(message) {
            this.errorMessage = message;
            this.showErrorPopup = true;
        },

        isValidName(name) {
            if (!name || name.trim().length < 2) {
                return false;
            }

            const nameRegex = /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF\s']+$/;
            return nameRegex.test(name.trim());
        },

        validateStep(step) {
            this.formErrors = {};
            this.fieldErrors = {};

            switch (step) {
                case 1:
                    // Step 1: Hero landing - no validation needed
                    return true;

                case 2: {
                    // Step 2: Name, DOB, Sex
                    let hasError = false;
                    let errorMessage = '';

                    // Validate first name
                    if (!this.people.first_name || this.people.first_name.trim() === '') {
                        this.setFieldError('first_name');
                        hasError = true;
                        errorMessage = 'Please enter your first name';
                    } else if (!this.isValidName(this.people.first_name)) {
                        this.setFieldError('first_name');
                        hasError = true;
                        if (this.people.first_name.trim().length < 2) {
                            errorMessage = 'First name must be at least 2 characters long';
                        } else {
                            errorMessage = 'First name can only contain letters, spaces, and apostrophes';
                        }
                    }

                    // Validate last name
                    if (!this.people.last_name || this.people.last_name.trim() === '') {
                        this.setFieldError('last_name');
                        hasError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter your last name';
                        }
                    } else if (!this.isValidName(this.people.last_name)) {
                        this.setFieldError('last_name');
                        hasError = true;
                        if (!errorMessage) {
                            if (this.people.last_name.trim().length < 2) {
                                errorMessage = 'Last name must be at least 2 characters long';
                            } else {
                                errorMessage = 'Last name can only contain letters, spaces, and apostrophes';
                            }
                        }
                    }

                    // Validate DOB
                    const { mm, dd, yyyy } = this.people.dob;

                    if (!mm) {
                        this.setFieldError('dob_mm');
                        hasError = true;
                    }
                    if (!dd) {
                        this.setFieldError('dob_dd');
                        hasError = true;
                    }
                    if (!yyyy) {
                        this.setFieldError('dob_yyyy');
                        hasError = true;
                    }

                    if (mm && dd && yyyy && !this.isValidDate(mm, dd, yyyy)) {
                        this.setFieldError('dob_mm');
                        this.setFieldError('dob_dd');
                        this.setFieldError('dob_yyyy');
                        hasError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter a valid date of birth';
                        }
                    }

                    // Validate gender
                    if (!this.people.gender) {
                        this.setFieldError('gender');
                        hasError = true;
                    }

                    if (hasError) {
                        this.showError(errorMessage || 'Please complete all required fields');
                        return false;
                    }

                    this.people.dobMMDDYYYY = `${mm}/${dd}/${yyyy}`;
                    break;
                }

                case 3: {
                    // Step 3: Email and Phone
                    let hasError = false;
                    let errorMessage = '';

                    if (!this.isValidEmail) {
                        this.setFieldError('email');
                        hasError = true;
                        errorMessage = 'Please enter a valid email address';
                    }

                    if (!isValidUsPhone(this.people.phone)) {
                        this.setFieldError('phone');
                        hasError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter a valid US phone number';
                        }
                    }

                    if (hasError) {
                        this.showError(errorMessage);
                        return false;
                    }

                    if (!this.people.agree_to_phone) {
                        this.smsConsentError = 'Please agree to receive SMS communications to continue';
                        this.triggerSmsConsentShake();
                        return false;
                    }
                    break;
                }

                case 4:
                    // Step 4: Pharmacy info - no validation needed
                    return true;

                case 5:
                    // Step 5: Inclusions - no validation needed
                    return true;

                case 6:
                    // Step 6: Payment - validation handled separately
                    return true;
            }

            return true;
        },

        triggerSmsConsentShake() {
            this.smsConsentShake = false;
            this.$nextTick(() => {
                this.smsConsentShake = true;
                setTimeout(() => {
                    this.smsConsentShake = false;
                }, 700);
            });
        },

        async handleSubmit() {
            if (!this.validateStep(this.active_el)) {
                return;
            }

            // Step 1: Hero landing - fire questionnaire_start then advance
            if (this.active_el === 1) {
                try {
                    if (window.tracking) {
                        window.tracking.event('questionnaire_start', { funnel_step: 1, form: "urgent_care" });
                    }
                } catch(error) {
                    console.log(error);
                }
                this.active_el++;
                return;
            }

            // Step 2: Name/DOB/Sex - fire gender/age events, age check then advance
            if (this.active_el === 2) {
                try {
                    if (window.tracking) {
                        window.tracking.event('gender', { funnel_step: 2, form: "urgent_care" });
                        window.tracking.event('age', { funnel_step: 3, form: "urgent_care" });
                    }
                } catch(error) {
                    console.log(error);
                }
                
                if (this.people.dob.yyyy > 2007) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years."
                        }
                    });
                    return;
                }
                this.active_el++;
                return;
            }

            // Step 3: Email/Phone - submit to intake-form API then advance
            if (this.active_el === 3) {
                const emailCheckPassed = await this.handleEmailCheck();
                if (!emailCheckPassed) {
                    return;
                }
                try {
                    const cleanedPhone = cleanUsPhone(this.people.phone);

                    this.isSubmitting = true;

                    let sessionId = null;
                    try {
                        sessionId = await window.tracking.assertSession();
                        this.people.tracking_session_id = sessionId;
                    } catch(error) {
                        if (window.trackingSessionId) {
                            sessionId = window.trackingSessionId;
                            this.people.tracking_session_id = sessionId;
                        }
                    }

                    const payload = {
                        first_name: this.people.first_name,
                        last_name: this.people.last_name,
                        email: this.people.email,
                        phone: cleanedPhone,
                        gender: this.people.gender,
                        dobMMDDYYYY: this.people.dobMMDDYYYY,
                        weight: 0,
                        desired_weight: 0,
                        heightInInches: 0,
                        form_type: 'urgent_care',
                        source_web: this.people.source_web,
                        agree_to_phone: this.people.agree_to_phone,
                        user_agent: window.navigator.userAgent,
                        ip_address: this.people.ip_address,
                        tracking_session_id: sessionId
                    };

                    const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            "Access-Control-Allow-Origin": "*"
                        }
                    });

                if (response.data.status === 'success') {
                    try {
                        if (window.tracking) {
                            window.tracking.event('email_complete', { funnel_step: 4, form: "urgent_care" });
                            window.tracking.event('phone_added', { funnel_step: 5, form: "urgent_care" });
                            window.tracking.event('questionnaire_end', { funnel_step: 6, form: "urgent_care" });
                            window.tracking.event('partial', {
                                funnel_step: 7,
                                event_id: crypto.randomUUID(),
                                form: "urgent_care"
                            });
                        }
                    } catch(error) {
                        console.log(error);
                    }
                    
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.active_el++;
                }
                } catch (error) {
                    console.error('Form submission error:', error);
                    this.showError('There was an error submitting your form. Please try again.');
                } finally {
                    this.isSubmitting = false;
                }
                return;
            }

            // Step 4: Pharmacy info - just advance
            if (this.active_el === 4) {
                this.active_el++;
                return;
            }

            // Step 5: Inclusions - fire add_to_cart, advance and init card element
            if (this.active_el === 5) {
                try {
                    if (window.tracking) {
                        window.tracking.event('add_to_cart', {
                            funnel_step: 8,
                            // Carried no amount at all until now, so this funnel reported
                            // a cart worth nothing and no ad platform could bid on it.
                            event_value: this.getTotalOrderAmount(),
                            currency: 'USD',
                            quantity: 1,
                            form: "urgent_care"
                        });
                    }
                } catch(error) {
                    console.log(error);
                }

                this.active_el++;
                return;
            }
        },

        // Pre-fill form from Vuex user/shipping data (only fills empty fields)
        prefillFromUserData() {
            const user = this.user;
            const shipping = this.$store.getters.shipping;

            if (user) {
                if (!this.people.first_name && user.first_name) this.people.first_name = user.first_name;
                if (!this.people.last_name && user.last_name) this.people.last_name = user.last_name;
                if (!this.people.email && user.email) this.people.email = user.email;
            }

            if (shipping) {
                if (!this.customerInfo.addressLine1 && shipping.address_line_1) this.customerInfo.addressLine1 = shipping.address_line_1;
                if (!this.customerInfo.addressLine2 && shipping.address_line_2) this.customerInfo.addressLine2 = shipping.address_line_2;
                if (!this.customerInfo.city && shipping.city) this.customerInfo.city = shipping.city;
                if (!this.customerInfo.state && shipping.state) this.customerInfo.state = shipping.state;
                if (!this.customerInfo.zip && shipping.zip) this.customerInfo.zip = shipping.zip;
            }
        },

        getTotalOrderAmount() {
            return this.paymentInfo.amount || 0;
        },

        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.showError('Our shipping partners do not deliver to PO Box addresses.');
                return;
            }
            this.customerInfo.addressLine1 = address.street;
            this.customerInfo.addressLine2 = address.address_line2 || '';
            this.customerInfo.city = address.city;
            this.customerInfo.state = this.normalizeState(address.state);
            this.customerInfo.zip = address.zip;
        },

        normalizeState(stateInput) {
            if (!stateInput) return '';
            const trimmed = stateInput.trim();
            // Already a 2-char abbreviation
            if (/^[A-Z]{2}$/.test(trimmed.toUpperCase()) && Object.values(this.allState).includes(trimmed.toUpperCase())) {
                return trimmed.toUpperCase();
            }
            // Try to match full state name
            const abbr = this.allState[trimmed] || this.allState[trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase()];
            return abbr || trimmed;
        },

        isValidStateAbbr(state) {
            return /^[A-Z]{2}$/.test(state) && Object.values(this.allState).includes(state);
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },

        async updateAddress() {
            try {
                this.customerInfo.id = this.user.id;
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                throw new Error('Failed to update address');
            }
        },

        validateAddress(address) {
            if (!address.addressLine1 || !address.city || !address.state || !address.zip) {
                return { valid: false, message: 'Please enter a complete shipping address.' };
            }
            // Louisiana and Mississippi are prohibited by state law. Checked
            // before the abbreviation test so the customer gets the real
            // reason instead of "invalid state".
            if (isRestrictedState(address.state)) {
                return { valid: false, message: RESTRICTED_STATE_MESSAGE };
            }
            if (!this.isValidStateAbbr(address.state.toUpperCase())) {
                return { valid: false, message: 'Please enter a valid 2-letter state abbreviation (e.g. FL, CA, NY).' };
            }
            return { valid: true };
        },

        handlePaymentError(message) {
            this.paymentError = true;
            this.errorMessage = message || 'Invalid card details. Please check your card information.';
            this.submitted = false;
        },

        handlePaymentToken(pmToken) {
            this.paymentInfo.cardToken = pmToken;
            this.paymentInfo.paymentMethod = 'card';
            this.submitted = true; // belt-and-suspenders: already set at the pay-button entry before confirmPayment()
            this.processPayment();
        },

        async handleExpressPayment(ev) {
            if (this.submitted) { ev.complete('fail'); return; } // a charge is already in flight
            try {
                this.submitted = true;
                this.correlationId = crypto.randomUUID();
                this.paymentError = false;
                this.paymentInfo.cardToken = ev.tokenId;
                this.paymentInfo.cardDetails = {
                    number: `XXXXXXXXXXXX${ev.card.last4}`,
                    expiration_month: ev.card.exp_month,
                    expiration_year: ev.card.exp_year,
                    cardBin: '',
                    cardBrand: ev.card.brand,
                    cardLast4: ev.card.last4,
                };
                this.paymentInfo.cardLast4 = ev.card.last4;
                this.paymentInfo.cardBrand = ev.card.brand;
                this.paymentInfo.paymentMethod = ev.methodName === 'apple-pay' ? 'apple_pay' : 'google_pay';
                if (ev.payerName && !this.people.first_name) {
                    const nameParts = ev.payerName.split(' ');
                    this.people.first_name = nameParts[0] || '';
                    this.people.last_name = nameParts.slice(1).join(' ') || '';
                }
                if (ev.payerEmail && !this.people.email) {
                    this.people.email = ev.payerEmail;
                }
                await this.processPayment();
                ev.complete('success');
            } catch (error) {
                console.error('[Checkout] Express payment error:', error);
                ev.complete('fail');
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please try again.';
                this.submitted = false;
            }
        },

        blinkAddress() {
            this.addressBlink = true;
            setTimeout(() => { this.addressBlink = false; }, 1500);
        },

        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            const shippingValidation = this.validateAddress(this.customerInfo);
            if (!shippingValidation.valid) {
                this.paymentError = true;
                this.errorMessage = shippingValidation.message;
                this.blinkAddress();
                this.submitted = false;
                return false;
            }

            const pmToken = await this.$refs.stripePayment.confirmPayment();
            if (!pmToken) {
                this.submitted = false;
                return false;
            }
        },

        async processPayment() {
            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;
                this.paymentInfo.medication = 'urgentcare';

                let sessionId = "";
                try {
                    sessionId = await window.tracking.assertSession();
                } catch(error) {
                    if (window.trackingSessionId) {
                        sessionId = window.trackingSessionId;
                    }
                }

                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    plan_id: '698397c07f9cbdeda6c20f1a',
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    totalOrderAmount: this.getTotalOrderAmount(),
                    cartItems: [{
                        plan_id: '698397517f9cbdeda6c20f16',
                        id: '6983971b7f9cbdeda6c20f14',
                        product_id: '6983971b7f9cbdeda6c20f14',
                        name: 'Urgent Care Visit',
                        price: 39.99,
                        retail_price: 39.99,
                        terms: 0,
                        quantity: 1,
                        is_addon: false
                    }],
                    cartTotal: 39.99,
                    cartTotalNoDiscount: 39.99,
                    useExistingCard: false,
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: this.people.ip_address || 'unknown',
                    tracking_session_id: sessionId
                };

                // ===== COMMENTED OUT: Original endpoint =====
                // const response = await this.$axios.post(`${this.baseUrl}/api/checkout-urgent-care`, paymentData);
                // ===== END COMMENTED OUT =====
                const response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });
                let amountCharged = paymentData.amount / 100;

                if (response.data.status === 'success') {
                    let orderId = response.data.orderId;
                    if (!orderId && response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                        orderId = response.data.prescriptionPreauths[0].orderId;
                    }
                    // Fire purchase event
                    try {
                        if (window.tracking) {
                            let txnId = response.data.transaction_id;
                            if (!txnId && response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                                txnId = response.data.prescriptionPreauths[0].transactionId;
                            }
                            if (!txnId) txnId = `${response.data.customerId}_${Date.now()}`;
                            window.tracking.event('purchase', {
                                funnel_step: 9,
                                event_value: amountCharged,
                                currency: 'USD',
                                transaction_id: txnId,
                                order_id: orderId,
                                event_id: crypto.randomUUID(),
                                quantity: 1,
                                form: "urgent_care"
                            });
                        }
                    } catch(e) { console.log(e); }
                    // Save purchased products to localStorage
                    const purchasedItems = paymentData.cartItems.map(item => ({
                        name: item.name,
                        price: amountCharged.toFixed(2)
                    }));
                    localStorage.setItem('productsPurchased', JSON.stringify(purchasedItems));

                    await this.updateAddress();
                    let transactionIdentifier;
                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e);
                        transactionIdentifier = `${Date.now()}`;
                    }

                    // Keep submitted = true through the redirect so the overlay
                    // and disabled button persist until the next page loads.
                    // Resetting here re-enables the button mid-navigation, opening
                    // a duplicate-charge window.
                    this.pushToRoute(amountCharged, transactionIdentifier, orderId);
                } else {
                    this.errorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                    this.paymentError = true;
                     this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || "";
                this.submitted = false;
            }
        },

        pushToRoute(amountCharged, transaction_id, orderId) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                this.$router.push({
                    path: `/urgent-care-start/${orderId}`,
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    path: `/urgent-care-start/${orderId}`
                });
            }
        }
    },

    watch: {
        active_el() {
            // Save progress when step changes
            this.saveProgress();

            // Wait for DOM update, then scroll to top
            this.$nextTick(() => {
                const questionDiv = document.querySelector('.step_forminfo_div, .quizquestiondiv2-copy, .step4_div, .step6_div');
                if (questionDiv) {
                    const header = document.querySelector('.section-fixed-prognav');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20;

                    const elementPosition = questionDiv.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'auto'
                    });
                } else {
                    window.scrollTo(0, 0);
                }
            });
        },

        // Auto-save when form data changes
        people: {
            deep: true,
            handler() {
                this.saveProgress();
            }
        },

        'people.first_name'() {
            this.clearFieldError('first_name');
        },
        'people.last_name'() {
            this.clearFieldError('last_name');
        },
        'people.email'() {
            this.clearFieldError('email');
        },
        'people.phone'() {
            this.clearFieldError('phone');
        },
        'people.gender'() {
            this.clearFieldError('gender');
        },
        'people.dob.mm'() {
            this.clearFieldError('dob_mm');
        },
        'people.dob.dd'() {
            this.clearFieldError('dob_dd');
        },
        'people.dob.yyyy'() {
            this.clearFieldError('dob_yyyy');
        }
    }
}
</script>

<style scoped>
.flow-step1-headers {
    margin-bottom: 15px;
}

.sms-phone-disclaimer {
    font-size: 11px;
    line-height: 1.4;
    color: #6b7280;
    margin: -8px 0 16px;
}

.sms-phone-disclaimer-link {
    color: inherit;
    text-decoration: underline;
}

@media screen and (max-width: 768px) {
    .sms-phone-disclaimer {
        font-size: 10px;
    }
}

.div-block-2247.phone .pay-button + .enroll-disclaimer-div.form {
    margin-top: 8px;
}

.div-block-2247.phone .pay-button + .enroll-disclaimer-div.form .enroll-checkbox-field.form {
    margin-bottom: 0;
}

/* SMS consent checkbox (beside disclaimer, above Continue button) */
.div-block-2247.phone.sms-actions {
    position: relative;
    margin-top: -4px;
}
.sms-consent-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 8px 0 0;
    padding: 8px 10px;
    border: 1px solid transparent;
    border-radius: 9px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}
.sms-consent-row .sms-phone-disclaimer {
    margin: 0;
    cursor: pointer;
}
.sms-consent-checkbox {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: #205089;
    cursor: pointer;
}
.sms-consent-row-error {
    border-color: #dc3545;
    background-color: rgba(220, 53, 69, 0.05);
}
.sms-consent-error {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    margin: 0 0 4px;
    color: #dc3545;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
}
.sms-consent-shake {
    animation: smsConsentShake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.sms-consent-shake .sms-consent-checkbox {
    animation: smsConsentPulse 0.6s ease both;
}
@keyframes smsConsentShake {
    10%, 90% { transform: translateX(-1px); }
    20%, 80% { transform: translateX(2px); }
    30%, 50%, 70% { transform: translateX(-4px); }
    40%, 60% { transform: translateX(4px); }
}
@keyframes smsConsentPulse {
    0%, 100% { transform: scale(1); }
    30% { transform: scale(1.3); }
    60% { transform: scale(0.95); }
}

.page {
    height: 100vh !important;
}

.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.w-input.field-error,
.w-select.field-error {
    border: 2px solid #dc3545 !important;
}

.loading-overlay2 {
    position: fixed;
    inset: 0;
    z-index: 99999999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.flow-ctrls-div .form-back-link {
    display: none !important;
}

.flow-ctrls-div {
    justify-content: center !important;
}

@media screen and (max-width: 991px) {
    .section-fixed-prognav {
        position: relative !important;
        z-index: 99999 !important;
        background-color: white !important;
        /* ADJUST THIS VALUE to change spacing below header (0-50px) */
        margin-bottom: 30px !important;
        padding-bottom: 0 !important;
    }

    .section_checkout-flow {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .flow_wrap {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .glpquiz_div {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .quiz_herodiv {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

@media screen and (max-width: 375px) {

    .quiz_heroviddiv,
    .background-video-10 {
        height: 430px;
    }

    .flex-input-div.dob {
        margin-bottom: 1px;
    }

    .div-block-2251 {
        margin-top: 0px;
    }

    .text-block-1686 {
        font-size: 12px;
    }
}

@media screen and (max-width: 490px) {
    .div-block-2251 {
        margin-top: 5px;
    }
    .flow-inclusions-header {
        font-size: 26px;
    }
}

@media screen and (max-width: 479px) {
    .image-651
 {
        width: 16px;
    }
}

@media screen and (max-width: 375px) {
    .flow-inclusions-header[data-v-d0ce333a] {
        margin-top: 15px;
        line-height: 33px;
        font-size: 24px;
    }
    .enroll-header {
        flex-direction: column;
        align-items: left;
        padding-bottom: 5px;
        display: flex;
        margin-top: 7px;
        font-size: 32px;
    }

    .form-3-things-div {
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 5px;
    }

    .formhero-sub {
        text-align: left;
        width: 100%;
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 24px;
    }

    .formhero-sub[data-v-71c43630] {
        text-align: left;
        width: 100%;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 5px;
    }

    .product-name-2-copy {
        font-size: 16px;
    }

    .section-fixed-prognav[data-v-d0ce333a] {

        margin-bottom: 5px !important;
    }

    .enroll-checkbox-label.w-form-label {
        font-size: 9px;
    }
}

@media screen and (max-width: 350px) {
    .enroll-header {
        font-size: 30px;
    }

}

.checkout-checkbox-text {
    font-size: 16px;
}

/* Fix dropdown overflow issue on step 18 */
.flow-payment-div {
    overflow: visible !important;
}

.flow_step3-form-div {
    overflow: visible !important;
}

.checkout-form {
    overflow: visible !important;
}

.flow-dropdown-sum {
    overflow: visible !important;
    position: relative;
}

.dropdown-list-18 {
    position: relative !important;
    z-index: 1000;
}

span.select-icon {
    position: absolute;
    top: 15px;
    left: 5px;
}

.selectwrap {
    position: relative;
}

.checkout-flow-input.thirds {
    padding-left: 30px;
}

.checkout-flow-dropdown {
    padding-left: 25px;
}

.selectwrap input#birth-month {
    width: 100%;
}
.tosspan {
    position: absolute;
    font-size: 8px;
    bottom: -3px;
    color: gray;
}
.email-check-error {
    color: #dc3545;
    font-size: 13px;
    margin-top: 4px;
}
.email-error-highlight {
    border-color: #dc3545 !important;
    background-color: #fff5f5 !important;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.modal-content {
    background: white;
    padding: 30px;
    border-radius: 12px;
    max-width: 450px;
    width: 90%;
    text-align: center;
}
.modal-content h3 {
    margin: 0 0 12px;
    font-size: 20px;
}
.modal-content p {
    margin: 0 0 24px;
    color: #555;
    font-size: 15px;
    line-height: 1.5;
}
.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}
.modal-btn {
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
    border: none;
}
.modal-btn.cancel {
    background: #e9ecef;
    color: #333;
}
.modal-btn.login {
    background: #0c9ac4;
    color: white;
}

/* Express Checkout */
.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    background: white;
    border: 1px solid #d8dbe0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* NOTE: Uses .pe-divider instead of .divider — webflow CSS defines .divider { width: 1px } which would turn this vertical. */
.pe-divider {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    margin: 12px 0;
    border: none;
    background: transparent;
}

.pe-divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.pe-divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.address-section {
    margin-bottom: 20px;
}

.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}
</style>
